import React, { useEffect, useState } from 'react';
import { Button, Table } from 'antd';

function CableOperatorDetails({ allData }) {
  console.log(allData);

  const [data, setData] = useState([]);
  // const [dataLimit, setDataLimit] = useState(3); // Limit to 3 rows by default
  const [showAll, setShowAll] = useState(false); // Toggle for showing all data

  useEffect(() => {
    setData(allData);
  }, [allData]);

  // Define columns for the table
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'Charges',
      dataIndex: 'charges',
    },
    {
      title: 'Depreciation Monthly',
      dataIndex: 'depreciationMonthly',
    },
    {
      title: 'Yearly Depreciation',
      dataIndex: 'depreciationYearly',
    },
    {
      title: 'Revenue',
      dataIndex: 'revnue',
    },
    {
      title: 'Total Connection',
      dataIndex: 'totalConnection',
    },
    {
      title: 'Transmitter Life',
      dataIndex: 'transmitorLife',
    },
    {
      title: 'Transmitter Cost',
      dataIndex: 'transmitorCost',
    },
  ];

  // Handle "View All" button click
  // const handleViewAll = () => {
  //   setShowAll(!showAll);
  //   setDataLimit(showAll ? 3 : data.length); // Toggle between 3 and all rows
  // };

  return (
    <div className="container">
      <div className="row">
        {data && data.length > 0 ? (
          <div className="col-12 mb-4">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <Table
                    dataSource={data} // Limit the data shown based on dataLimit
                    columns={columns}
                    pagination={false}
                    rowKey={(record) => record.id} // Assuming each record has a unique id
                  />
                  {/* {data.length > 3 && (
                    <Button
                      onClick={handleViewAll}
                      block
                      style={{ width: '100%', marginTop: '10px' }}
                    >
                      {showAll ? 'Show Less' : 'View All'}
                    </Button>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-12 mb-4">
            <div className="card text-center">
              <div className="card-body">
                <p>No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CableOperatorDetails;
